import {HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {AuthService} from '../services/auth-service.service';

/**
 * Interceptor that adds the selected 'warehouseId' to all outgoing
 * requests to the backend API (/api/).
 * This ensures multi-warehouse consistency without manual parameter passing in every service.
 * It also prevents 400 Bad Request by ensuring 'undefined' or 'null' is never sent.
 *
 * Important: many services build the full URL with query string (e.g. BaseService fetchData).
 * In that case {@link HttpRequest#params} is often empty; cloning with only {@code params.set}
 * replaces the entire query string and drops {@code _sort}, {@code _limit}, {@code _offset},
 * breaking Core PostgREST-style endpoints (e.g. order-service list).
 */
export const warehouseInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const warehouseId = authService.getSelectedWarehouseId();

  if (!req.url.includes('/api/')) {
    return next(req);
  }

  const finalWarehouseId =
    warehouseId != null && !isNaN(Number(warehouseId))
      ? String(warehouseId)
      : '1';

  if (/[?&]warehouseId=/.test(req.url)) {
    return next(req);
  }

  if (req.params.keys().length > 0) {
    return next(
      req.clone({
        params: req.params.set('warehouseId', finalWarehouseId),
      })
    );
  }

  const sep = req.url.includes('?') ? '&' : '?';
  return next(
    req.clone({
      url: `${req.url}${sep}warehouseId=${encodeURIComponent(finalWarehouseId)}`,
    })
  );
};
